/**
 * Labstep
 *
 * @module components/Folder/Action/Add/Bulk
 * @desc Action to add parentEntity to folder
 */

import { EntityActionAddSearchBulkContainer as EntityActionAddSearchBulk } from 'labstep-web/components/Entity/Action/AddSearch/Bulk';
import { useHasAccessMultiple } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ICONS } from 'labstep-web/constants/icons';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderActionAddBulkProps } from './types';

export const FolderActionAddBulk: React.FC<
  FolderActionAddBulkProps
> = ({ entityName, parentEntities, options }) => {
  const parentEntityIdsAccessAddRemoveObject = useHasAccessMultiple(
    entityName,
    parentEntities.map((e) => e.id),
    `folder_${entityName}:${Action.add_remove}` as Action,
  );

  if (parentEntities.length === 0) {
    return null;
  }

  const parentEntitiesWithAddRemovePermission = parentEntities.filter(
    (e) => parentEntityIdsAccessAddRemoveObject[e.id],
  );

  return (
    <EntityActionAddSearchBulk
      dataCy="components/Folder/Action/Add/Bulk"
      entityName={Folder.entityName}
      parentEntities={parentEntities}
      parentEntitiesWithPermission={
        parentEntitiesWithAddRemovePermission
      }
      actionText={`Add to ${Folder.getHumanReadableEntityName(false, true)}`}
      icon={ICONS.folder.primary}
      options={options}
      searchSelectProps={{
        labelKey: 'folder_path',
        extraParams: { count: 50 },
      }}
    />
  );
};
